import { number } from "vue-types";
import { BaseSymbol } from "./model";

export const UserAPI = {
  GetCurrentUser: "/user/currentUser",
  GetPhone: "/user/captcha/phone",
  GetEmail: "/user/captcha/email",
  GetForgetPasswordSendEmail: "/user/forget/password/send/email",
  GetCheckPhone: "/user/check/phone",
  GetCheckEmail: "/user/check/email",
  GetCheckInviteCode: "/user/check/invitecode",
  GetCheckUsername: "/user/check/username",
  GetUserConfig: "/user/config/get",

  PostRegister: "/user/register",
  PostLogin: "/user/login",
  PostSsoExchange: "/user/sso/exchange",
  PostOutLogin: "/user/outLogin",
  PostCheckToken: "/user/checkToken",
  PostUserResetPassword: "/user/reset/password",
  PostUserResetPasswordByEmail: "/user/reset/password/email",
  PostUserConfigSave: "/user/config/save",

  PostUserUpdateNickname: "/user/update/nickname",
  PostUserUpdateEmail: "/user/update/email",
  PostUserUpdatePhone: "/user/update/phone",
  PostUserUpdatePassword: "/user/update/password",
  PostSendUpdateEmailCode: "/user/send/update/email/code",

  GetCaptchaGenerate: "/user/captcha/generate",
  GetCaptchaImage: "/user/captcha/image",
  GetCaptchaRequired: "/user/captcha/required",

  GetUserApiWs: "/user/api/ws",

  GetUserApiList: "/user/api/list",
  GetUserApiAll: "/user/api/all",
  PostUserApiSave: "/user/api/save",
  PostUserApiSaveActive: "/user/api/save/active",
  PostUserApiDelete: "/user/api/delete",

  GetUserApiGroupList: "/user/api/group/list",
  PostUserApiGroupSave: "/user/api/group/save",
  PostUserApiGroupDelete: "/user/api/group/delete",

  GetUserApiBalanceCurrency: "/user/api/balance/currency",
  GetUserApiBalanceUnique: "/user/api/balance/unique",
  GetUserApiBalanceList: "/user/api/balance/list",
  GetUserApiBalanceAllow: "/user/api/balance/allow",
  GetUserApiBalanceDataList: "/user/api/balance/data/list",
  GetUserApiBalanceAll: "/user/api/balance/all",

  GetUserApiPositionLeverage: "/user/api/position/leverage",
  GetUserApiPositionList: "/user/api/position/list",
  GetUserApiOpenOrderList: "/user/api/order/open/list",
  GetUserApiHistoryOrderList: "/user/api/order/history/list",

  GetUserOrderPositionList: "/user/order/position/list",
  GetUserOrderPositionCloseList: "/user/order/position/close/list",

  PostUserApiTransfer: "/user/api/transfer",
  PostUserApiAssetTransfer: "/user/api/asset/transfer",

  PostUserApiMarginSmallLiability: "/user/api/margin/small-liability", //全仓杠杆小额负债转换
  PostUserApiMarginSmallBnb: "/user/api/margin/small-bnb", //全仓杠杆账号小额兑换BNB
  PostUserApiPortfolioMarginRepay: "/user/api/portfolio/margin/repay", //统一账号归还指定币种负债
  PostUserApiPortfolioContractAutoRepay:
    "/user/api/portfolio/contract/auto-repay", //统一账号自动清还合约负余额
  PostUserApiPortfolioAutoCollect: "/user/api/portfolio/auto-collect", //统一账号资金归集

  GetUserApiMarginAccount: "/user/api/margin/account",
  GetUserApiMarginIsolatedAccount: "/user/api/margin/isolated/account",
  GetUserApiMarginMaxBorrowed: "/user/api/margin/maxBorrowable",
  GetUserApiMarginMaxTransfer: "/user/api/margin/maxTransferable",
  GetUserApiMarginInterestHistory: "/user/api/margin/interestHistory",
  PostUserApiMarginLoanRepay: "/user/api/margin/loan-repay",
  PostUserApiMarginTransfer: "/user/api/margin/transfer",

  GetUserApiPositionSetting: "user/api/position/setting",
  PostUserApiPositionSettingUpdate: "/user/api/position/setting/update",

  // GetUserApiLeverageAssetMode: "/user/api/leverage/assetMode",
  // GetUserApiLeveragePositionMode: "/user/api/leverage/positionMode",
  // GetUserApiLeveragePositionSetting: "/user/api/leverage/positionSetting",

  // PostUserApiLeverageAssetModeUpdate: "/user/api/leverage/assetMode/update",
  // PostUserApiLeveragePositionModeUpdate:
  //   "/user/api/leverage/positionMode/update",
  // PostUserApiLeverageRatioUpdate: "/user/api/leverage/ratio/update",
  // PostUserApiLeverageMarginTypeUpdate: "/user/api/leverage/marginType/update",

  GetUserLoginLogList: "/user/loginLog/list",

  GetUserTradeTemplateList: "/user/tradetemplate/list",
  PostUserTradeTemplateSave: "/user/tradetemplate/save",
  PostUserTradeTemplateDelete: "/user/tradetemplate/delete",

  GetUserSymbolSubscribeList: "/user/symbolsubscribe/list",
  PostUserSymbolSubscribeAdd: "/user/symbolsubscribe/add",
  PostUserSymbolSubscribeRemove: "/user/symbolsubscribe/remove",

  GetSelectObserverList: "/user/select/observer/list",
  GetObserverUserApiList: "/user/observer/user/api/list",
  GetFinanceUserApiList: "/user/finance/user/api/list",
};

export const OrderAPI = {
  PostDoOrder: "/order/doOrder",
  PostClosePosition: "/order/closePosition",
  PostCancelOrder: "/order/cancelOrder",
  PostExchangeCancelOrder: "/order/exchange/cancelOrder",
  GetUserOrderList: "/order/user/list",
  GetTwapOrderList: "/order/twap/list",
  GetCurrentBailList: "/order/user/current/list",
  GetTwapOrderChildList: "/order/twap/child/list",
  GetTwapOrderChildWs: "/order/twap/child/ws",
};

export const OrderV2API = {
  PostDoOrder: "/order/v2/doOrder",
  PostClosePosition: "/order/v2/closePosition",
};

export const BaseAPI = {
  GetSymbols: "/client/base/symbols",
  GetIntervals: "/client/base/intervals",
  GetDictionary: "/client/base/dictionary",

  GetExchangeInfo: "/client/base/exchange/info",

  GetSymbolsAI: "/client/base/symbols/ai",
  GetSymbolsAIWs: "/client/base/symbols/ai/ws",
  GetSymbolsMargin: "/client/base/symbols/margin",
  GetSymbolsMultiTickersWs: "/client/base/symbols/multi-tickers/ws",

  GetSymbolsFundingRateNewestList:
    "/client/base/symbols/funding/rate/newest/list",
  GetSymbolsFundingRateHistoryList:
    "/client/base/symbols/funding/rate/history/list",

  GetLeverageBrackets: "/client/base/leverage/brackets",
  GetAISelectSymbol: "/client/base/symbols/ai/select",

  PostContactUs: "/client/base/contact",
  PostApplicationCareer: "/client/base/application/career",

  GetSymbolsAstockName: "/client/base/symbols/astock/name",
};

export const KlinesAPI = {
  GetKlineList: "/client/klines/list",
  GetKlineListHistory: "/client/klines/list/history",
  GetKlineListWs: "/client/klines/list/ws",
  GetKline24hData: "/client/klines/data/24h/ws",
};

export const DepthAPI = {
  GetDepth: "/client/depth/depth",
  GetDepthWs: "/client/depth/depth/ws",
  GetDepthOrderbookWs: "/client/depth/orderbook/ws",
};

export const DataAPI = {
  GetFngList: "/fng/list",
  GetSpreadArbListWs: "/spread/v2/ws",
};

export const WsRestAPI = {
  Gateway: "/ws/rest",
};

export const StrategyAPI = {
  GetTemplate: "/strategy/template",
  GetRobotTemplate: "/strategy/robot/template",
  GetInstanceList: "/strategy/client/instance/list", //1
  GetInstanceInfoList: "/strategy/client/instance/info/list",
  GetInstanceInfoStatVo: "/strategy/client/instance/info/stat/vo", //1
  GetInstanceArbOptionNetvalues:
    "/strategy/client/instance/arb/option/netvalues",
  GetInstanceArbSpreadData: "/strategy/client/instance/arb/spread/data",
  GetInstnaceArbSpreadExecutionAnalysis:
    "/strategy/client/instance/arb/spread/execution/analysis",
  GetInstanceArbSpreadMonitorData:
    "/strategy/client/instance/arb/spread/monitor/data",

  GetInstanceArbStatData: "/strategy/client/instance/arb/stat/data",

  GetInstanceInfoListRobot: "/strategy/client/instance/info/list/robot",
  GetInstancePositionList: "/strategy/client/instance/position/list", //1
  GetInstanceMarks: "/strategy/client/instance/marks",

  GetNetValueData: "/strategy/netValue/data",
  GetInfoValueData: "/strategy/infoValue/data",
  PostStart: "/strategy/client/start",
  PostStop: "/strategy/client/stop",
  PostUpdate: "/strategy/client/update",

  GetRobotInstanceList: "/strategy/client/instance/robot/list",
  GetRobotInfoList: "/strategy/client/robot/info/list",
  GetRobotPositionList: "/strategy/client/robot/position/list",
  PostRobotStart: "/strategy/client/robot/start",
  PostRobotStop: "/strategy/client/robot/stop",
  GetStartTemplateList: "/strategy/client/startTemplate/list",
  PostStartTemplateSave: "/strategy/client/startTemplate/save",
  PostStartTemplateDelete: "/strategy/client/startTemplate/delete",
  GetCurrency: "/admin/strategy/selectcoin",

  GetObserverInstanceList: "/strategy/client/observer/instance/list", //1
  GetObserverInstanceInfoStatVo:
    "/strategy/client/observer/instance/info/stat/vo", //1
  GetObserverInstancePositionList:
    "/strategy/client/observer/instance/position/list", //1

  GetEnvSelect: "/strategy/client/env/select",

  GetProfitData: "/strategy/client/profit/data",
  GetNetValueSummaryData: "/strategy/client/netValueSummary/data",
  GetNetValueSummaryAnalysis: "/strategy/client/netValueSummary/analysis",
};

export const HftAPI = {
  GetHftOrderNewest: "/hft/order/newest",
  GetHftOrderList: "/hft/order/list",
  GetHftOrderListPage: "/hft/order/list/page",
  GetHftOrderIds: "/hft/order/ids",
  GetHftOrderWs: "/hft/order/ws",
};
export const MsgAPI = {
  GetUserMsgWs: "/msg/user/ws",
  GetUserMsgList: "/msg/user/list",
  PostUserMsgRead: "/msg/user/read",
  GetUserMsgLoad: "/msg/user/load",
  GetUserMsgLoadBefore: "/msg/user/load/before",
  GetUserMsgV2Ws: "/msg/v2/user/ws",
  GetAiNewsWs: "/msg/ai/news/ws",
};

export const StatsAPI = {
  GetStatsMain: "/stats/main",
  GetStatsMainOnly: "/stats/main/only",
  GetStats24H: "/stats/24h",
  GetStatsRobot: "/stats/robot",
  GetStatsRobotData: "/stats/robot/data",
};

export const OptionAPI = {
  GetBookList: "/option/book/list",
  GetBookListWs: "/option/book/ws",
  GetTicker: "/option/ticker",
  GetTickerList: "/option/ticker/list",
  GetTickerListWs: "/option/ticker/list/ws",
};
export const CopulaAPI = {
  GetPools: "/copula/pools",
};

/** Strategy instance lifecycle statuses (aligned with rest-api strategy status constants). */
export const StrategyInstanceStatus = {
  TRADING: "TRADING",
  STOPPED: "STOPPED",
  BACKTEST_FINISHED: "BACKTEST_FINISHED",
  /** Live instance still running but trading halted (display-only status). */
  TRADING_HALTED: "TRADING_HALTED",
  INTERRUPTED: "INTERRUPTED",
} as const;

export type StrategyInstanceStatusValue =
  typeof StrategyInstanceStatus[keyof typeof StrategyInstanceStatus];

/** Statuses shown in the Running tab instance list. */
export const STRATEGY_INSTANCE_RUNNING_STATUSES: StrategyInstanceStatusValue[] =
  [
    StrategyInstanceStatus.TRADING,
    StrategyInstanceStatus.BACKTEST_FINISHED,
    StrategyInstanceStatus.TRADING_HALTED,
  ];

export interface BaseResponse {
  code: number;
  msg: string;
  success: boolean;
  data: unknown;
}

export interface PageResponseData {
  page_size: number;
  page: number;
  total: number;
  results: unknown[];
  filters: any;
}
export interface OrderRequest {
  ex_type: string;
  ac_type: string;
  symbol: string;
  trigger_price: number;
  ori_vol: number;
  ori_qty: number;
  is_price_deviated: boolean;
  trade_type: number;
  off_set: number;
  order_mode: number;
  except_price: number;
  user_id: string;
  account_id: string;
  type: string;
  order_types: string;
  api_id: number;
}

export interface OrderV2Request {
  exchange: string;
  params: OrderV2Param[];
  api_id: number;
  sync_ratio?: number;
}
export interface OrderV2Param {
  accountType: string;
  symbol: string;
  price: number;
  quantity: number;
  orderType: string;
  orderSide: string;
  orderId: string;
  clientOrderId: string;
  positionSide: string;
  timeInForce: string;
  reduceOnly: boolean;
  newClientOrderId: string;
  isIsolated: boolean;
  isMargin: boolean;
  ccy: string;
  isAlgo?: boolean;
  orderAlgoType?: string;
  triggerPrice: number;
  triggerType: string;
  accountMode?: string;

  quantity_ccy: string;
  // 附加止盈止损 attach_oco_tp_price
  attachOcoTpOrderPrice?: number;
  attachOcoTpTriggerPrice?: number;
  attachOcoSlOrderPrice?: number;
  attachOcoSlTriggerPrice?: number;

  // 双向止盈止损
  ocoTpTriggerPx?: number;
  ocoTpOrdPx?: number;
  ocoTpOrdType?: string;
  ocoSlTriggerPx?: number;
  ocoSlOrdPx?: number;
  ocoSlOrdType?: string;

  /** Bitget 合约：OPEN 开仓 / CLOSE 平仓 */
  TradeSide?: string;
}
export interface UserRequest {
  phone?: string;
  email?: string;
  username: string;
  password: string;
  captcha_id: string;
  captcha_value: string;
}

export interface PageAPIParams {
  pageSize?: number;
  page?: number;
  sortField?: string;
  sortOrder?: number;
  [key: string]: any;
}

export interface KlineRequest {
  exchange: string;
  account_type: string;
  symbol: string;
  interval: string;
  limit: number;
  start?: number;
  end?: number;
  spread_merge?: "redis";
}

export interface DepthRequest {
  exchange: string;
  account_type: string;
  symbol: string;
  limit?: number;
}

export interface StrategyReq {
  strategyId: string; //策略ID*
  acType: string; //交易类型* 现货:spot U合约:future 币合约:swap
  symbol: string; //交易对*
  exType?: string; //交易所
  ApiKeyInfo?: ApikeyInfo; //API信息*

  MarketMakerReq?: MarketMakerReq; //做市策略参数*
  SorReq?: SorReq; //智能路由策略参数*
  ShockGridReq?: ShockGridReq; //震荡网格策略参数
  TerReq?: TerReq; //趋势延续策略参数
  VolumeLatticeReq?: VolumeLatticeReq; //量格策略参数
  ArbSpreadReq?: ArbSpreadReq; //价差套利策略参数
  ArbOptionReq?: ArbOptionReq; //期权套利策略参数
  ArbFactorReq?: ArbFactorReq; //因子套利策略参数
  AStockExecuteMultiReq?: AStockExecuteMultiReq; //A股執行参数
  // StrongBackReq?: StrongBackReq; //强势高抛低吸策略参数
  ShockReverseReq?: ShockReverseReq; //顺势震荡高抛低吸策略参数
  RateGridReq?: RateGridReq;
  TrendContinueRobotReq?: TrendContinueRobotReq;
  StrongGridReq?: StrongGridReq;
  SmartExecuteReq?: SmartExecuteReq;
  ArbFundingReq?: ArbFundingReq;
  ArbStatReq?: ArbStatReq; //统计套利策略参数
  startEnv?: string; //是否测试
}
export interface ApikeyInfo {
  apiId: number | undefined; //用户api*
}

export interface StrongGridReq {
  //symbolbase
  ac_type?: string; //交易类型* 现货:spot U合约:future 币合约:swap
  symbol?: string; //交易对*
  ex_type?: string; //交易所

  //utilsbase
  instance_id?: string; //实例ID
  strategy_name?: string; //实例名
  is_margin: boolean; //是否杠杆
  is_isolated: boolean; //是否逐仓杠杆
  is_post_only?: boolean; //是否只做maker,只对直接下单有效
  is_clear_position?: boolean; //是否清仓
  is_clear_all_position?: boolean; //是否全部清仓
  max_trade_qty?: number; //最大开仓金额

  //stronggrid
  is_open_pos?: boolean; //是否开仓
  is_long?: boolean; //是否做多
  buy_step_percent?: number; //买单间隔比例
  sell_step_percent?: number; //卖单间隔比例
  init_hold?: number; //初始仓位
  take_profit_price?: number; //止盈价格
  stop_loss_price?: number; //止损价格
  order_num?: number; //单笔下单量
  orderQty?: number; //单笔下单额
  kline_interval?: string; //K线周期
}

export interface TrendContinueRobotReq {
  ac_type?: string; //交易类型* 现货:spot U合约:future 币合约:swap
  symbol?: string; //交易对*
  ex_type?: string; //交易所
  instance_id?: string; //实例ID
  strategy_name?: string; //实例名
  is_margin: boolean; //是否杠杆
  is_isolated: boolean; //是否逐仓杠杆
  dk_flag?: number; //机器人支持类型 1:多 0:双向 -1:空
  max_trade_qty?: number; //单次调用工具最大可用金额
  all_max_trade_qty?: number; //总最大可用金额
  is_spot?: boolean; //是否支持现货
  n?: number; //只交易交易额前n名
  buy_step_percent?: number; //买单间隔比例
  sell_step_percent?: number; //卖单间隔比例
}
// export interface StrongBackReq {
//   instance_id?: string; //实例ID
//   strategy_name?: string; //实例名
//   is_long?: boolean; //是否做多
//   is_strong?: boolean; //是否强势判定
//   is_margin: boolean; //是否杠杆
//   is_isolated: boolean; //是否逐仓杠杆
//   kline_interval?: string; //k线周期
//   open_quantile?: number; //开仓分位数
//   close_quantile?: number; //平仓分位数
//   order_num_u?: number; //下单金额,暂时通用
//   order_num?: number; //下单量,暂时通用
//   orderQty?: number; //单笔下单额
// }
export interface ShockGridReq {
  ac_type?: string; //交易类型* 现货:spot U合约:future 币合约:swap
  symbol?: string; //交易对*
  ex_type?: string; //交易所
  instance_id?: string; //实例ID
  strategy_name?: string; //实例名
  is_post_only?: boolean; //是否只做maker,只对直接下单有效
  is_long?: boolean; //是否做多
  is_time_sharing?: boolean; //是否分时
  is_std?: boolean; //是否使用标准差
  is_follow_market?: boolean; //是否跟随市场
  is_margin: boolean; //是否杠杆
  is_isolated: boolean; //是否逐仓杠杆
  side_effect_type: string; //杠杆借还类型，杠杆时有效 NO_SIDE_EFFECT, MARGIN_BUY, AUTO_REPAY,AUTO_BORROW_REPAY
  max_trade_qty?: number; //最大开仓金额
  init_hold?: number; //当前持仓
  take_profit_price?: number; //止盈价格
  stop_loss_price?: number; //止损价格
  min_percent?: number; //最小网格间隔
  max_percent?: number; //最大网格间隔
  order_num?: number; //下单量,暂时通用
  orderQty?: number; //单笔下单额
  buy_step_percent?: number; //买单间隔比例
  sell_step_percent?: number; //卖单间隔比例
  high_limit?: number; //网格区间高点
  low_limit?: number; //网格区间低点
  std_interval?: string; //标准差区间
  n?: number; //挂单对数
  is_clear_position?: boolean; //是否清仓
  is_clear_all_position?: boolean; //是否全部清仓
  is_equivalent?: boolean; //是否等比

  init_hold_ccy: string; //初始持仓币种 BTC USDT USD CONTRACT_CONT
  max_trade_qty_ccy: string; //可用金额币种 BTC USDT USD CONTRACT_CONT
  order_num_ccy: string; //下单量币种 BTC USDT USD CONTRACT_CONT

  is_not_re_quote: boolean; //是否不重新报价
  is_use_current_position: boolean; //是否使用现有仓位
  is_move_grid: boolean; //是否移动网格
}

export interface TerReq {
  ac_type?: string;
  symbol?: string;
  ex_type?: string;
  strategy_name?: string;
  max_trade_qty?: number;
  max_trade_qty_ccy?: string;
  mode: number;
  maker_only: boolean;
}

export interface VolumeLatticeReq {
  ac_type?: string;
  symbol?: string;
  ex_type?: string;
  strategy_name?: string;
  max_trade_qty?: number;
  max_trade_qty_ccy?: string;
  initial_qty?: number;
}

export interface SmartExecuteReq {
  instance_id?: string;
  strategy_name?: string;
  // MinSplitUsd    float64                  `json:"min_split_usd"`    //最小拆单额
  // MaxSplitUsd    float64                  `json:"max_split_usd"`    //最大拆单额
  // BaseSplitCount int64                    `json:"base_split_count"` //基准拆单数量
  // IsCollabExec   bool                     `json:"is_collab_exec"`   //是否协同执行
  // IsSyncOrder    bool                     `json:"is_sync_order"`    //是否同步挂单
  min_split_usd?: number; //最小拆单额
  max_split_usd?: number; //最大拆单额
  base_split_count?: number; //基准拆单数量
  is_collab_exec?: boolean; //是否协同执行
  is_trend_exec?: boolean; //是否趋势执行
  is_sync_order?: boolean; //是否同步挂单
  data: SmartExecuteSingleData[];
  stats?: SmartExecuteBasisSpreadStats;
}

export interface SmartExecuteSingleData {
  tp_id?: number;
  ex_type?: string;
  ac_type?: string;
  symbol?: string;
  api_id?: number;
  is_margin?: boolean;
  max_trade_qty?: number;
  max_trade_qty_ccy?: string;
  order_side?: string;
  is_long?: boolean;
  is_both_position?: boolean;
  time_in_force?: string;
  side_and_type?: string;
  base_symbol?: BaseSymbol;
  side_effect_type?: string;
}

export interface SmartExecuteBasisSpreadStats {
  totalCount: number; // 总记录数
  avgSlippageBps: number; //平均滑点(基点)
  maxSlippageBps: number; //最大滑点(基点)
  minSlippageBps: number; //最小滑点(基点)
  totalSlippageLoss: number; //累计滑点影响(USD,正值=收益,负值=损失)
  avgSlippageLoss: number; //平均滑点影响(USD,正值=收益,负值=损失)
  maxSlippageLoss: number; //最大单次滑点影响(USD,正值=收益,负值=损失)
  minSlippageLoss: number; //最小单次滑点影响(USD,正值=收益,负值=损失)
  avgWaitDurationMs: number; //平均等待时长(毫秒)
  updateTime: string; //最后更新时间
}

export interface ArbFundingReq {
  instance_id?: string;
  strategy_name?: string;
  max_trade_qty?: number; //最大可用金额
  trigger_funding_rate_threshold?: number; //触发资金费率阈值
  trigger_funding_rate_minute?: number; //触发资金费率启动时间 单位分钟 比如10代表结算前10分钟开始执行
  trigger_spot_side?: string; //触发现货方向 BUY/SELL/ALL 默认BUY
  min_split_usd?: number; //最小拆单额
  max_split_usd?: number; //最大拆单额
  base_split_count?: number; //基准拆单数量
  is_collab_exec?: boolean; //是否协同执行
  is_trend_exec?: boolean; //是否趋势执行
  is_sync_order?: boolean; //是否同步挂单
  currency_white_list: string[]; //币种白名单 自动套取该列表的币种
  arb_funding_execute_list_map?: [key: string, value: ArbFundingExecute[]]; //所有历史执行器（包含统计数据）
}

export interface ArbFundingExecute {
  currency?: string; // 币种
  execute_id: string; // 执行器ID
  status: string; // 当前执行器状态
  open_position_data: ArbFundingExecutePositionData; //开仓数据
  close_position_data: ArbFundingExecutePositionData; //平仓数据

  // 多次结算相关字段
  settle_records: ArbFundingRateSettleRecord[]; // 结算历史记录
  accumulated_funding_profit: number; // 累计资金费收益
  estimated_slippage: number; // 预估滑点（万分之1）

  cft: number; //当前资金费率时间
  cfr: number; //当前资金费率
  tt: number; //触发时间戳
  st: number; //结算时间戳
  ct: number; //完成时间戳
  pfr: number; // 预估资金费率
  rfr: number; // 实际资金费率
  pfp: number; // 预估资金费收益
  rfp: number; // 实际资金费收益
  scf: number; // 平仓现货收益
  fcf: number; // 平仓合约收益
  tof: number; // 总手续费
  tbq: number; // 总借币数量
  tbc: string; //总借币币种
  tbi: number; // 总借币利息
  tnp: number; // 总净收益(预估资金费收益+平仓现货收益+平仓合约收益-总手续费-总借币利息)
}

export interface ArbFundingExecutePositionData {
  st: number; // 开始时间
  et: number; // 结束时间
  sos: string; // 现货订单方向
  fos: string; // 合约订单方向
  spq: number; // 现货成交额
  fpq: number; // 合约成交额
  spa: number; // 现货数量
  fpa: number; // 合约数量
  spac: string; // 现货数量单位
  fpac: string; // 合约数量单位
  spap: number; // 现货平均价格
  fpap: number; // 合约平均价格
  spf: number; // 现货手续费
  fpf: number; // 合约手续费
}

export interface ArbFundingRateSettleRecord {
  settle_time: number; // 结算时间
  funding_rate: number; // 结算时的资金费率
  next_funding_time: number; // 下次资金费率时间
  profit_amount: number; // 此次结算收益
}

export interface ArbSpreadReq {
  ac_type?: string; //交易类型* 现货:spot U合约:future 币合约:swap
  symbol?: string; //交易对*
  ex_type?: string; //交易所
  instance_id?: string; //实例ID
  strategy_name?: string; //实例名

  binance_api_id?: number;
  okx_api_id?: number;
  bybit_api_id?: number;
  gate_api_id?: number;
  max_trade_qty?: number;
  min_open_spread?: number; //最低套利开仓价差
  min_close_spread?: number; //最低套利平仓价差
  max_order_qty?: number; //单笔最大下单量
}

export interface ArbOptionReq {
  ac_type?: string; //交易类型* 现货:spot U合约:future 币合约:swap
  symbol?: string; //交易对*
  ex_type?: string; //交易所
  instance_id?: string; //实例ID
  strategy_name?: string; //实例名
}

export interface ArbFactorReq {
  ac_type?: string; //交易类型* 现货:spot U合约:future 币合约:swap
  symbol?: string; //交易对*
  ex_type?: string; //交易所

  instance_id?: string; //实例ID
  strategy_name?: string; //实例名

  is_post_only?: boolean; //是否只做maker,只对直接下单有效
  is_clear_position?: boolean; //是否清仓
  is_clear_all_position?: boolean; //是否全部清仓
  max_trade_qty?: number; //最大开仓金额
  max_trade_qty_ccy: string; //可用金额币种 BTC USDT USD CONTRACT_CONT

  exec_min_order_qty: number;
  exec_max_split_order: number;
  exec_timeout: number;
  exec_order_timeout: number;
  exec_timeout_taker: boolean;
}

export interface AStockExecuteMultiReq {
  ac_type?: string; //交易类型* 现货:spot U合约:future 币合约:swap
  symbol?: string; //交易对*
  ex_type?: string; //交易所

  instance_id?: string; //实例ID
  strategy_name?: string; //实例名

  is_post_only?: boolean; //是否只做maker,只对直接下单有效
  is_clear_position?: boolean; //是否清仓
  is_clear_all_position?: boolean; //是否全部清仓
  max_trade_qty?: number; //最大开仓金额
  max_trade_qty_ccy: string; //可用金额币种 BTC USDT USD CONTRACT_CONT

  exec_min_order_qty: number;
  exec_max_split_order: number;
  exec_timeout: number;
  exec_order_timeout: number;
  exec_timeout_taker: boolean;
}

//顺势震荡高抛低吸
export interface ShockReverseReq {
  ex_type?: string; //交易所类型
  ac_type?: string; //账户类型
  symbol?: string; //symbol
  instance_id?: string; //实例ID
  strategy_name?: string; //实例名
  is_post_only?: boolean; //是否只做maker,只对直接下单有效
  // kline_interval_long?: string; // 长周期
  // kline_interval_short?: string; // 短周期
  stop_loss_percent?: number; //止损比例
  take_profit_percent?: number; //止盈比例
  order_num?: number; //总下单量,会分成十份
  orderQty?: number; //单笔下单额
  max_trade_qty?: number; //可用金额
  is_margin: boolean; //是否杠杆
  is_isolated: boolean; //是否逐仓杠杆
  is_clear_position?: boolean; //是否清仓
  is_clear_all_position?: boolean; //是否全部清仓
  dk_flag?: number;
  high_limit?: number; //网格区间高点
  low_limit?: number; //网格区间低点
  kline_interval?: string; //K线周期
}

export interface RateGridReq {
  instance_id?: string; //实例ID
  strategy_name?: string; //实例名
  is_post_only?: boolean; //是否只做maker,只对直接下单有效
  is_margin: boolean; //是否杠杆
  is_isolated: boolean; //是否逐仓杠杆
  is_clear_position?: boolean; //是否清仓
  is_clear_all_position?: boolean; //是否全部清仓

  long_symbol: RateGridSymbol; //汇率基础交易对
  short_symbol: RateGridSymbol; //汇率目标交易对
  rate_step_percent?: number; //间隔比例
  max_trade_qty?: number; //可用金额
}

export interface RateGridSymbol {
  ex_type: string; //交易所类型
  ac_type: string; //账户类型
  symbol: string; //symbol
  init_hold?: number; //可用仓位
  order_num?: number; //下单数量
  orderQty?: number; //单笔下单额
}

export interface MarketMakerReq {
  account?: string;
  isClearPosition?: boolean; //是否清仓
  isClearAllPosition?: boolean; //是否全部清仓
  accountType?: string;
  exchangeTypes?: string;
  symbolName?: string;
  instance_id?: string; //实例id
  strategy_name?: string; //实例名
  // isLong?: boolean; //是否做多
  isPostOnly: boolean; // 是否只做maker
  isStdev: boolean; // 是否启用标准差
  isTimeline: boolean; // 是否启用分时
  // isFollewMarket: boolean; // 订单是否跟随市场移动
  isMargin: boolean; //是否杠杆
  isIsolated: boolean; //是否逐仓杠杆
  sideEffectType: string; //杠杆借还类型，默认值NO_MARGIN，杠杆时有效 NO_SIDE_EFFECT, MARGIN_BUY, AUTO_REPAY,AUTO_BORROW_REPAY
  orderNum?: number; // 单笔下单量
  initHoldL?: number; // 投入策略币的数量 多头数量
  initHoldS?: number; // 投入策略币的数量 空头数量
  exposureLimit?: number; // 最大开仓金额
  maxPercent?: number; // 最大间隔比例
  minPercent?: number; // 最小间隔比例
  // maxPosition?: number; // 持仓上限
  // minPosition?: number; // 持仓下限
  targetPosition?: number; // 目标仓位
  targetPercent?: number; // 当前时刻目标间隔比例
  highLimit?: number; //区间高点
  lowLimit?: number; //区间低点
  // stdevFactor?: number; //标准差系数
  // takeProfitPrice?: number; //止盈价
  // stopLossPrice?: number; //止损价
  orderQty?: number; //单笔下单额
  stdInterval?: string; //k线周期
  trendInterval?: string;

  numLevels?: number; //深度档位数量
  // priceInterval?: number; //价格间隔
  maxInventory?: number; //最大库存
  minInventory?: number; //最小库存
  windowSize?: number;
  isGrantObserver?: boolean; //是否授权观察者
  observerUserIds?: number[]; //观察者用户id

  smartPriceWindowSize?: number; // 智能价格窗口大小
  smartPriceNumLevels?: number; // 智能价格深度档位数量

  OFIFWindowSize?: number; // 智能价格窗口大小
  OFIFNumLevels?: number; // 智能价格深度档位数量
  env?: string;

  orderStep?: number; //挂单间隔

  // IsLiquidity bool    `json:"isLiquidity"` // 是否启用流动性
  // MinOrderNum float64 `json:"minOrderNum"` // 单笔最小下单量 USD
  // MaxOrderNum float64 `json:"maxOrderNum"` // 单笔最大下单量 USD
  isLiquidity?: boolean; // 是否启用流动性
  minOrderNum?: number; // 单笔最小下单量 USD
  maxOrderNum?: number; // 单笔最大下单量 USD

  isCombination?: boolean; // 是否组合

  liquidityRatio?: number; //流动性倍率
  directionalBias?: number; //方向性
  productType?: string; //产品类型

  levelTotal?: number; //挂单数
  isHedge?: boolean; //启用对冲

  execMode?: string; // 执行模式：live（实盘）| sim（模拟）
  dataSource?: string; // 行情数据源：mmap | ws

  /** copula.copula_pairs primary key; 0 for single-symbol mode */
  pairId?: number;

  tpData?: MarketMakerTpData[];
}

export interface MarketMakerTpData {
  tpId?: string;
  tpKey?: string;
  exchangeType?: string;
  accountType?: string;
  productType?: string;
  symbolName?: string;
  symbolKey?: string;
  maxTradeAmount?: number;
  sideEffectType?: string;
  instrumentStatus?: string;
  timestamp?: number;
}

export interface SorReq {
  account?: string;
  instance_id?: string; //实例id
  strategy_name?: string; //实例名
  isStdev?: boolean;
  isPostOnly?: boolean;
  isTimeline?: boolean;
  isGrantObserver?: boolean;
  observerUserIds?: number[];
  env?: string;
  tpData: SorTpData[];
  levelTotal?: number;
  levelStart?: number;
  levelInterval?: number;
  isImpactPercent?: boolean; // 是否启用冲击量
  impactLevel?: number; //冲击量档位
  impactMultiple?: number; //冲击量倍率
  impactNumPerMinute?: number; //冲击数/分钟
  maxOrderAmount?: number; //最大下单金额
  maxOrderCurrency?: string; //最大下单币种
  isFollowBook?: boolean; //是否跟随盘口
  isCollabExec?: boolean; //是否协同执行

  isLiquidity?: boolean; // 是否启用流动性
  minOrderNum?: number; // 单笔最小下单量 USD
  maxOrderNum?: number; // 单笔最大下单量 USD
  liquidityRatio?: number; //流动性倍率

  isCombination?: boolean; // 是否组合
}

export interface ArbOptionJson {
  equity: number; //账户资产净值
  total_equity_usd: number; //账户资产净值(美元)
  im: number; //初始保证金率
  mm: number; //维护保证金率
  total_floating_profit_loss_usd: number; //损益
  total_profit_loss: number; //损益(美元)
  roi: number; //ROI
  total_delta: number; //Delta
  total_gamma: number; //Gamma
  total_vega: number; //Vega
  total_theta: number; //Theta
  total_rho: number; //Rho
  ccy: string; //币种
  bn_account_equity: number; //币安资金规模
  liquidationPrice: number; //强平价格
  isDeribitFuture: boolean; //是否deribit期货对冲
  total_floating_profit_loss_usd2: number; //期货对冲盈亏USD
  total_profit_loss2: number; //期货对冲盈亏币
  total_size2: number; //期货对冲持仓数量
  total_average_price_usd2: number; //期货对冲持仓均价
  futureIndexPrice: number; //期货对冲标记价格
}

export interface SorTpData {
  tpId?: string;
  apiId?: string;
  accessKey?: string;
  secretKey?: string;
  exchangeType?: string;
  accountType?: string;
  symbolName?: string;
  maxTradeAmount?: number;
  orderSide?: string;
  positionSide?: string;
  orderType?: string;
  timeInForce?: string;
  baseCurrency?: string;
  quoteCurrency?: string;
  sideAndType?: string;
  symbol?: BaseSymbol;
  exceptPrice?: number;
  // impactPercent?: number;
  isMargin?: boolean; //是否杠杆账户
  isIsolated?: boolean; //是否逐仓杠杆
  sideEffectType?: string; //现货普通买入 NO_SIDE_EFFECT 现货杠杆类型 MARGIN_BUY 启用杠杆 AUTO_REPAY 自动还款 AUTO_BORROW_REPAY 自动借款还款

  productType?: string; //产品类型
}

export interface TransferReq {
  api_id: number;
  asset: string;
  amount: number;
  type: string;
}

export interface AssetTransferReq {
  api_id: number;
  asset: string;
  amount: number;
  from: string;
  to: string;
  from_symbol?: string;
  to_symbol?: string;
}

export interface MarginTransferReq {
  api_id: number; //必须 操作的api_id
  asset: string; //必须 划转币种
  amount: number; //必须 划转数量
  is_isolated: boolean; //必须 是否逐仓杠杆划转
  is_to_main: boolean; //必须 是否向主账户划转
  symbol: string; //逐仓必须 逐仓交易对，配合逐仓使用
}

export interface RobotReq {
  robotTemplateId: string;
  allMaxTradeQty: number;
  maxTradeQty: number;
  ApiKeyInfo: ApikeyInfo; //API信息*
}

export interface UserApiWsReq {
  req_id: string;
  req_type: string;
  currency?: string;
  exchange?: string;
  account_type?: string;
  symbol?: string;
  api_id?: number;
}

export interface UserApiWsRes {
  req: UserApiWsReq;
  res: any;
}

export interface UserApiMarginLoanRepayReq {
  api_id: number; //必须 操作的api_id
  is_loan: boolean; //必须 true:借币 false:还币
  is_isolated: boolean; //非必须 是否逐仓杠杆
  symbol: string; //非必须 逐仓交易对，配合逐仓使用
  asset: string; //必须 借币还币币种
  amount: number; //必须 借币还币数量
}

export interface UserApiMarginMaxReq {
  api_id: number;
  asset: string;
  is_isolated: boolean;
  symbol: string;
}

export interface UserApiMarginInterestHistoryReq {
  api_id: number;
  asset?: string; //NO 币种, 比如, BTC
  symbol?: string; //NO 逐仓交易对，适用于逐仓查询
  start_time?: number; //NO
  end_time?: number; //NO
  current?: number; //NO	当前查询页。 开始值 1. 默认:1
  size?: number; //NO	默认:10 最大:100
  archived?: boolean; //NO	默认: false. 查询6个月以前的数据，需要设为 true
}

export interface UserApiLeverageReq {
  api_id: number; //YES 操作的api_id
  account_type: string; //YES 合约类型
  symbol?: string; //NO 交易对
  asset_mode?: boolean; //NO 联合保证金模式 true 联合保证金 false 单币种保证金
  position_mode?: boolean; //NO 仓位模式 true 双向持仓 false 单向持仓
  leverage_number?: number; //NO 杠杆倍数
  margin_type?: boolean; //NO 保证金模式 true 逐仓 false 全仓
}

export interface ExchangeCancelOrderRequest {
  account_type: string;
  symbol: string;
  api_id_list: number[];
  open_order_id: number;
}

export interface sorOrderRequest {
  account_type: string;
  symbol: string;
  quantity: number;
  quantity_ccy: string;
  leverage_mode: string;
  is_collab_exec: boolean;
  is_trend_exec: boolean;
  is_sync_order: boolean;
}

/** 单条 filter 内按 regime 择一执行的判定种类 */
export type KlineFactorPredicateKind =
  | "trend_with_open"
  | "trend_against_open"
  | "trend_block_open"
  | "range_allow_both"
  | "range_block_both"
  | "outside_range"
  | "inside_range"
  | "stoch_rsi_reversal"
  | "stoch_rsi_entry_cross"
  | "stoch_rsi_exit_cross"
  | "stoch_rsi_exit_independent"
  | "stoch_rsi_exit_with_signal";

export interface KlineFactorPredicate {
  kind: KlineFactorPredicateKind;
}

/** 单条开仓前 K 线因子规则（一个 period） */
export type KlineFactorType =
  | "sma"
  | "ema"
  | "wma"
  | "vwma"
  | "cci"
  | "rsi"
  | "natr_expand"
  | "ma"
  | "ma_cross"
  | "stoch_rsi";

export interface KlineFactorFilter {
  /** sma|ema|wma|vwma|cci|rsi|natr_expand|ma_cross|stoch_rsi；配置 ma 在 ValidateFilters 规范为 sma。natr_expand 取值是 TR/ATR 膨胀比，不是 NATR% */
  factor_type: KlineFactorType;
  /** 须为 periods 子集 */
  period: string;
  lengths: number[];
  range_low?: number;
  range_high?: number;
  predicates: KlineFactorPredicate[];

  // ma_cross 专用字段：快慢线类型与周期。
  ma_fast_type?: string; // sma|ema|wma|vwma
  ma_fast_length?: number; // >=2
  ma_slow_type?: string; // sma|ema|wma|vwma
  ma_slow_length?: number; // >=2

  /** stoch_rsi only. Missing values are filled before submit; explicit 0 is invalid. */
  stoch_length?: number; // [2,500], default 14
  smooth_k?: number; // [1,50], default 3
  smooth_d?: number; // [1,50], default 3
  exit_short_k_below?: number; // [0,100] and < range_high, default 20
  exit_long_k_above?: number; // [0,100] and > range_low, default 80
}

export type MaxHoldExitMode = "fixed_time" | "stoch_rsi_reversal";

/** daily | weekly 禁开仓窗口类型 */
export type NoTradeWindowType = "daily" | "weekly";

/** 不可交易时段配置（与策略端 no_trade_schedule 契约一致） */
export interface NoTradeSchedule {
  timezone: string;
  windows: NoTradeWindow[];
}

/** 单条 daily/weekly 半开区间黑名单窗口 [start, end) */
export interface NoTradeWindow {
  type: NoTradeWindowType;
  /** HH:mm（UI 固定秒 00；入站 HH:mm:ss 会截断） */
  start: string;
  end: string;
  /** weekly only: 1=Mon .. 7=Sun */
  start_dow?: number;
  end_dow?: number;
}

export type FuturesMarketSizingMode = "notional_first" | "discrete_neutral";

/** jsonData.symbols[] member; identity is member_key = {EX}_{AC}_{SYMBOL} */
export interface ArbStatMember {
  ex_type: string;
  ac_type: string;
  symbol: string;
  member_key?: string;
}

export type ExchangeApiIds = Record<string, number>;

export interface ArbStatReq {
  /** Legacy instance-level identity; must not be sent on Start/Update */
  ex_type?: string;
  ac_type?: string;
  symbol?: string;
  instance_id?: string; //实例ID
  strategy_name?: string; //实例名
  /** Per-exchange UserApi id; 0 = observe-only (no trading) */
  exchange_api_ids?: ExchangeApiIds;
  max_trade_qty?: number; // 可用金额（USDT）
  max_trade_qty_ccy?: string; // 可用金额币种
  stop_loss_pct?: number; // 紧急止损：总盈亏%跌破此值→平仓并停止策略，如 5.0=亏5%，0=不启用
  take_profit_pct?: number; // 止盈：总盈亏%超过此值→平仓并继续，如 2.0=盈2%，0=不启用
  max_position_size?: number; // 最大持仓价值（USDT）→超限则平仓并继续，0=不限制
  max_hold_time_ms?: number; // 最大持仓时间（毫秒），到点平仓；客户端表单默认 60 分钟（3600000 ms）。Stoch 谓词不替代该超时
  /** Legacy only. Loaded so it can be migrated into stoch predicates, then deleted. */
  max_hold_exit_mode?: MaxHoldExitMode | string;
  is_post_only?: boolean; // 是否只做maker
  is_both_position?: boolean; // 是否单向持仓；策略只允许 Hedge，须 false / 不传
  is_margin?: boolean; // 是否杠杆
  is_isolated?: boolean; // 是否逐仓
  side_effect_type?: string; // 杠杆借还类型

  // Copula 因子订阅配置（强制必填）
  factor_server_url?: string; // FactorServer WebSocket 地址
  symbols?: ArbStatMember[]; // 参与套利的 member 对象列表
  exclude_pairs?: string[]; // 完整 member_key 配对，如 "BINANCE_FUTURE_ETHUSDT|BINANCE_FUTURE_SOLUSDT"
  periods?: string[]; // K 线周期列表，默认 ["1m","5m","15m"]，如含 1h / 4h / 1d
  factor_throttle_ms?: number; // 因子推送节流毫秒数，默认 100
  base_quantity?: number; // 基础交易数量（scaled_transaction 的基准）

  /** 持仓期 5s 浮盈采样并在平仓时压缩写入 extend；省略/true=启用，显式 false 关闭 */
  enable_hold_pnl_curve?: boolean;
  /** 包络等分段数，默认 32，范围 8–128（多日持仓可酌情调大） */
  hold_pnl_envelope_segments?: number;

  /** FUTURESMKT 离散开仓 sizing（仅传统期货实例生效） */
  /** notional_first：连续名义（不限制）/ discrete_neutral：floor 对齐，无法对齐则拒开（默认） */
  futures_market_sizing_mode?: FuturesMarketSizingMode;
  /** discrete_neutral 下 |long-short|/min(long,short) 上限，默认 0.05 */
  futures_market_max_lot_skew_ratio?: number;
  /** PreCheck 要求 base_quantity >= ratio × 各品种单手名义，默认 1.0 */
  futures_market_min_base_qty_lot_ratio?: number;

  // Copula group_select 开仓参数
  copula_entry_threshold?: number; // 开仓阈值 t（copula score 域）；与客户端「开仓水位」d∈(0,1) 的关系：d=1−2t、t=(1−d)/2（例 d=0.8→t=0.1，d=0.85→t=0.075），默认 t=0.075
  copula_min_rho?: number; // 最小相关系数过滤，范围 [-1, 1]，默认 0.65。价差模式仍使用
  /** 空或 cp 为 CP 基准；spread 为价差基准。省略表示 CP */
  baseline_mode?: string;
  /** 价差、分数和相关性共用的单一周期，必须是 periods 中策略支持的一档 */
  spread_baseline_period?: string;
  /** |偏离| 须严格大于该 bps。省略或 <=0 时策略回填 15 */
  spread_open_dev_bps?: number;
  /** 配置半衰期（分钟）。短于 4 根 K 线时不改写入参 */
  spread_ema_half_life_min?: number;
  /** 价差模式两腿 |cumulScore| 阈值，范围 (0, 1]，与开仓水位无关。省略或 <=0 时策略回填 0.7 */
  spread_entry_score_threshold?: number;
  copula_min_confirm_periods?: number; // 配对开仓所需的最少独立确认周期数，默认 2

  // CopulaAllowedConfirmPeriodSets 开仓确认周期组合白名单：每项为逗号分隔周期，如 "1m,5m" 或 "1m,5m,15m"。
  // 顺序任意，与仓位内存储、报表统计键均按 Periods 配置顺序规范化。nil 或空切片表示不限制（默认）。
  copula_allowed_confirm_period_sets?: string[];

  copula_dyn_threshold_k?: number; // 动态阈值 z-score 系数 K，0=禁用，范围约 (0, 2]，表单默认 2.0
  copula_dyn_threshold_blend?: number; // 动态阈值混合系数 α，默认 0.6
  /** 开仓前 geomMean 须相对滚动窗口峰值回落的最小比例 p（0=关闭）；门控 gmMax >= geomMean/(1-p) */
  copula_entry_pullback_frac?: number;
  /** 启用回撤时 geomMean 缓冲最少点数；0 表示服务端 PreCheck 默认与动态阈值预热一致（60） */
  copula_entry_pullback_min_points?: number;
  /**
   * 峰值年龄门控：窗口峰值须至少稳定 N 个 slot 才允许入场；0 表示服务端默认 6。
   * 仅当 copula_entry_pullback_frac > 0 时生效。
   */
  copula_entry_pullback_peak_min_age?: number;
  /**
   * EWMA 斜率回看 slot 数；0 表示服务端默认 6。当前 EWMA 与 N slot 前比较以确认下行趋势。
   * 仅当 copula_entry_pullback_frac > 0 时生效。
   */
  copula_entry_ewma_slope_lag_slots?: number;

  /** coint_stop_loss / coint_trailing_stop 平仓后，再次开仓前须 copula 中性 */
  copula_reopen_after_loss_need_neutral?: boolean;

  /** 开仓 K 线因子过滤（价比 K 线剔末根；MA/CCI/RSI 用 close，natr_expand 用 OHLC 算 TR/ATR 膨胀比；有序 filters 外层 AND）；空列表=不启用 */
  /** predicate: trend_with_open | trend_against_open | trend_block_open | range_allow_both | range_block_both | outside_range | inside_range */
  copula_entry_kline_factor_filters?: KlineFactorFilter[];

  /**
   * 不可交易时段（开仓黑名单）：省略/空 windows=不限制。
   * 仅拦新开仓；半开区间 [start,end)；timezone 默认 Asia/Shanghai。
   */
  no_trade_schedule?: NoTradeSchedule;

  // Copula 平仓参数
  copula_exit_threshold?: number; // 信号回归平仓阈值（copula score 域），默认 0.5，前端可调范围 [0, 1]
  copula_rho_drop_threshold?: number; // 相关性降低比例触发平仓，默认 0.2
  /** Copula 策略1回归平仓是否要求最低浮盈；省略/false=关 */
  copula_revert_min_profit_enabled?: boolean;
  /** 相对有效止盈 C×gEff 的比例，范围 [0,1]；允许 0（只拦负浮盈）。开关关时不要带此键 */
  copula_revert_min_profit_frac?: number;

  // 协整仓位 PnL 平仓参数
  min_gain_coint?: number; // 协整组合止盈阈值（相对收益率），默认 0.0015
  max_drawdown_coint?: number; // 协整组合止损阈值（相对回撤），默认 0.0015
  /** 协整策略 3 动态止盈止损；none=与旧逻辑一致；tier=台阶抬损；trail=峰值跟踪；tier_trail=二者兼有 */
  coint_dynamic_pnl_exit?: string;
  /** 相对 MinGainCoint，浮盈达 C×MinGain×本系数后启用跟踪止损（trail / tier_trail），默认 1，范围 (0,1] */
  coint_trail_arm_frac?: number;
  /** 跟踪时允许自峰值 pnlPeak 回吐 C×MaxDrawdown×本系数（USDT），默认 1，须 >0 */
  coint_trail_pullback_mult?: number;
  /** 台阶一达线 C×MinGain×本系数则抬损；none/trail 下未用；tier/tier_trail 下省略或为 0 时 PreCheck 默认 0.5，范围 [0,1) */
  coint_tier1_gain_frac?: number;
  /** 台阶一后有效止损为 max(-C×MaxDrawdown, -C×MaxDrawdown×mult)；tier/tier_trail 且本批使用了台阶默认时若仍为 1 则 PreCheck 置 0.5，范围 (0,1] */
  coint_tier1_stop_mult?: number;
  /** 为 true 时协整 MinGain/MaxDrawdown 及 tier/trail 美元门槛按短窗相对全样本参考波动缩放 */
  coint_vol_scale_enabled?: boolean;
  /** 短窗一阶差分个数（≥2），默认 60；缓冲内需不少于本值+1 个 log 比率点且全样本差分不少于 32 才由服务端生效 */
  coint_vol_scale_window?: number;
  /** scale=sigma_short/sigma_ref 夹紧下限，默认 0.5 */
  coint_vol_scale_min_mult?: number;
  /** scale=sigma_short/sigma_ref 夹紧上限，默认 2.0 */
  coint_vol_scale_max_mult?: number;
  /** true 时浮盈达有效止盈一定比例后，按 log 价比 K 线 RSI 极值—回归触发提前平仓 */
  coint_ratio_rsi_exit_enabled?: boolean;
  /** RSI 周期（Wilder），默认 14，须 >=2 */
  coint_ratio_rsi_length?: number;
  /** 超买阈值（0～100），须 lower < upper */
  coint_ratio_rsi_upper?: number;
  /** 超卖阈值（0～100） */
  coint_ratio_rsi_lower?: number;
  /** 相对有效止盈的比例，浮盈达该比例后才允许 RSI 臂置位，默认 0.2，范围 (0,1] */
  coint_ratio_rsi_min_profit_frac?: number;
  /** true 时同时监控超买与超卖臂（与持仓方向解耦）；默认 false */
  coint_ratio_rsi_use_symmetric_arms?: boolean;

  // 冷却期参数
  cooldown_ms?: number; // 信号触发平仓后的冷却毫秒数，默认 100000（100s）
  risk_cooldown_ms?: number; // 风控触发平仓后的冷却毫秒数，默认 20000（20s）
  /** 连续 coint_stop_loss 次数达到后该 pair 冷静；0=服务端默认 1；关闭发 -1 */
  coint_consecutive_stop_loss_limit?: number;
  /** 连续止损冷静时长（毫秒）；limit>0 且未配时服务端默认 5400000（90 分钟） */
  coint_consecutive_stop_loss_cooldown_ms?: number;

  // 因子数据新鲜度
  copula_max_data_age_ms?: number; // 因子数据最大有效时间（毫秒），默认 5000（5s），0=不检查

  // 回放/回测配置
  is_replay?: boolean; // 是否回放模式，跳过实时市场订阅和因子订阅
  replay_start_time_ms?: number; // 回放开始时间（毫秒）
  replay_end_time_ms?: number; // 回放结束时间（毫秒）
  /** 流式历史回放倍速，仅在 maintain_intervals=true 时由 FactorServer 使用；0=未指定，发包前沿用 FactorSubscriber 默认 5.0 */
  replay_speed?: number;

  // TWAP 执行配置（Phase1 开仓）
  use_twap?: boolean; // 是否启用 TWAP MakerOnly 执行，false=市价 Taker
  twap_duration_ms?: number; // Phase1 开仓主执行窗(ms)，默认 60000
  twap_slice_count?: number; // Phase1 时间切片数，默认 5
  /** maker 挂单档位：ADAPTIVE（默认）/ MULTI_LEVEL / SINGLE */
  twap_maker_placement_mode?: string;
  /** MULTI_LEVEL 时挂档数，默认 3，范围 [2,5] */
  twap_maker_depth_levels?: number;
  /** 为 true 时启用 Phase1 分片/下单名义上下限；false 时忽略下列四参数 */
  twap_notional_bounds_enabled?: boolean;
  /** Phase1 时间分片单笔最小名义（USDT 等），PreCheck 默认 1000 */
  twap_slice_min_notional?: number;
  /** Phase1 时间分片单笔最大名义，默认 50000 */
  twap_slice_max_notional?: number;
  /** Phase1 片内首次挂单最小名义，默认 100 */
  twap_order_min_notional?: number;
  /** Phase1 片内首次挂单最大名义，默认 2000 */
  twap_order_max_notional?: number;

  /** 顶 order max 时随机下界比例 [0,1]；0=默认 0.9；1=关闭抖动 */
  twap_order_max_notional_jitter_min_ratio?: number;
  /** ADAPTIVE 运行时动态放大 per-leg order max；省略/true=启用，显式 false 关闭 */
  twap_adaptive_notional_mult_enabled?: boolean;
  /** 动态倍率上限；≤0 默认 3 */
  twap_adaptive_notional_mult_max?: number;

  /** 回放模拟限价成交：queue=队列模型（默认）；trade_cross=成交价穿越挂单价即全额成交 */
  sim_fill_mode?: string;

  // === 手续费率管控 ===
  /**
   * 外部可容忍的最高 maker 手续费率上限（开仓门控，平仓不受限）。
   * 当前实盘 maker 费率 > 本值时策略暂停开仓，直至费率回落至本值及以下。
   * 默认 0：仅 0 或负费率（返佣）才允许开仓；正值如 0.0001 表示费率 ≤ 0.0001 可开仓；
   * 负值如 -0.00003 表示需至少该返佣才允许开仓。
   * 纯现货开仓（信号内无合约腿）不使用本门控；回放模式下不生效（回放费率固定覆盖）。
   */
  max_maker_fee_rate?: number;
}
